import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import {
  AlertToolBox,
  CollapseComponent,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  FabricStyleBean,
  FabricStyleInventoryValuationCriteriaBean,
  FabricStyleInventoryValuationPrintRequest,
  FabricStyleInventoryValuationResultBean,
  FabricStyleSearchCriteria,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestReadRequest,
} from "../ds/ds.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { PopupFabricStyleModule } from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
class FabricStyleInventoryValuationInfo extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.fabricCodeRef = React.createRef();
    this.state = {
      pageTitle: "Fabric Style Inventory Valuation Info",
      isShowExitButton: true,
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      isShowExcelButton: false,
      isDisableFields: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      criteria: new FabricStyleInventoryValuationCriteriaBean(),
      error_list: [],
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      fabricColourPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricColorList: true,
      showAutoCompleteUOMPopupList: true,
      fabricStyleData: new FabricStyleBean(),
      isInquiryDatasFound: false,
      inquiryDataList: [],
      inquiryData: new FabricStyleInventoryValuationResultBean(),
      isShowFabricStyleModule: false,
      moduleForPopup: [],
      isShowColorLookup: false,
      isShowLookup: true,
      fabricStyleData: new FabricStyleBean(),
      fabricLookupHandler: null,
      colorLookupHandler: null,
      warehouseLookupHandler: null,
      uomsLookupHandler: null,
      warehouses: [],
      uoms: [],
      locationPageListForAutoCompleteList: new Array(),
      uomPopupPageListForAutoCompleteList: new Array(),
      showAutoCompleteLocationList: true,
      showAutoCompleteList: false,
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isCollapsible_open: true,
      is3PL: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let warehouses = attribute_cache.warehouses;
    if (warehouses != null || warehouses != undefined) {
      warehouses.map((attr) => {
        this.state.warehouses.push(attr);
      });
    }
    let uoms = attribute_cache.uoms;
    if (uoms != null || uoms != undefined) {
      uoms.map((attr) => {
        this.state.uoms.push(attr);
      });
    }
    this.initLookupHandlers();
    let criteria = this.state.criteria;
    criteria.uomCode = "YD";
    this.setState({ criteria: criteria });
  }
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
    let warehouseLookupHandler = new GenericAttributeLookupHandler(
      this.state.warehouses,
      "Warehouse"
    );
    this.setState({ warehouseLookupHandler: warehouseLookupHandler });
    let uomsLookupHandler = new GenericAttributeLookupHandler(
      this.state.uoms,
      "UOM"
    );
    this.setState({ uomsLookupHandler: uomsLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage();
  };
  loadPage = () => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing ...",
    });
    this.loadfabricStyleInventoryValuationInquiryList(criteria);
  };
  loadfabricStyleInventoryValuationInquiryList = (listRequest) => {
    if (
      SecurityAccessManager.FabricStyleInventoryValuationInfosInquiry_IsAccessible()
    ) {
      ReportService.inquireFabricStyleInventoryValuationInfos(
        listRequest,
        this.loadFabricStyleInventoryPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadFabricStyleInventoryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let inquiryData = new FabricStyleInventoryValuationResultBean();
      let valuationInfos = new Array();
      if (!isEmptyArray(response.data.result.valuationInfos)) {
        valuationInfos = response.data.result.valuationInfos;
        inquiryData = response.data.result;
        this.setState({
          isShowExcelButton: true,
          isShowPDFButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        inquiryDataList: valuationInfos,
        inquiryData: inquiryData,
        isShowClearCriteriaButton: false,
        isShowResetButton: true,
        isShowColorLookup: false,
        isShowLookup: false,
        isDisableFields: true,
        isCollapsible_open: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error" + error);
  };
  clearCriteria = () => {
    let criteria = new FabricStyleInventoryValuationCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    criteria.uomCode = "YD";
    this.setState({
      criteria: criteria,
      isShowColorLookup: false,
      isCollapsible_open: true,
    });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new FabricStyleInventoryValuationCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    criteria.uomCode = "YD";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowColorLookup: false,
      isShowLookup: true,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: false,
      isDisableFields: false,
      isCollapsible_open: true,
    });
    this.hideAlertCallBack();
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewFabricModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      moduleForPopup: [],
    });
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        isShowColorLookup: false,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
          });
        }
      }
    }
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByFabricCodeResponse = (response) => {
    if (
      response.data != null &&
      response.data.fabricStylePageList != null &&
      response.data.fabricStylePageList.fabricStyles != null
    ) {
      let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
      let simpleAutoCompleteList = new Array();
      if (fabricStyleData.length > 0 && fabricStyleData != null) {
        fabricStyleData.map((fabricStyle) => {
          let simpleItemBean = {
            code: fabricStyle.fabricStyleCode,
            description: fabricStyle.fabricStyleName,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        fabricPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.readandsetFabricStyleDetail(fabricStyleCode);
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "colorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
  };
  readFabricColourBySearchString(searchString) {
    let criteria = this.state.criteria;
    criteria.colorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(fabricStyleColourCode);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let criteria = this.state.criteria;
    criteria.colorCode = colorCode;
    this.setState({ criteria: criteria });
  };
  locationCodeOnChange = (e) => {
    let locationCode = e.target.value;
    this.state.showAutoCompleteLocationList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteLocationList;
    if (isEmpty(locationCode)) {
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      let criteria = this.state.criteria;
      criteria.locationCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteLocationList: showAutoCompleteList,
        criteria: criteria,
        showAutoCompleteSalesPersonList: suggestion,
      });
    } else if (showAutoCompleteList === true && locationCode !== "") {
      this.readLocationBySearchString(locationCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
  };
  readLocation = (locationCode) => {
    let locationBean = null;
    let locationData = null;
    this.state.warehouses.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.locationCode = locationBean.code;
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
    this.setState({ locationList: locationBean, locationData: locationData });
  };
  readLocationBySearchString = (searchString) => {
    let locationData = this.state.warehouses;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((sp) => {
        let locationBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ locationPageListForAutoCompleteList: filteredSuggestions });
  };
  locationEnterKeyEventHandler = (e) => {
    let locationCode = e.target.value;
    this.readLocation(locationCode);
    this.setState({
      locationPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteLocationList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteLocationList: showAutoCompleteList });
  };
  onPopupUomCodeChange = (e) => {
    let uomCode = e.target.value;
    this.state.showAutoCompleteUOMPopupList = true;
    let criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteUOMPopupList;
    if (isEmpty(uomCode)) {
      this.state.showAutoCompleteUOMPopupList = false;
      let showAutoCompleteList = this.state.showAutoCompleteUOMPopupList;
      let criteria = this.state.criteria;
      criteria.uomCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteUOMPopupList: showAutoCompleteList,
        criteria: criteria,
        uomPopupPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && uomCode !== "") {
      this.readPopupUomCodeBySearchString(uomCode);
    }
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  readPopupUomCodeBySearchString(searchString) {
    let uomCodeData = this.state.uoms;
    let simpleAutoCompleteList = new Array();
    if (uomCodeData.length > 0 && uomCodeData != null) {
      uomCodeData.map((uomCodeDatas) => {
        let simpleItemBean = {
          code: uomCodeDatas.code,
          description: uomCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteUomCodeLists) =>
        simpleAutoCompleteUomCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ uomPopupPageListForAutoCompleteList: filteredSuggestions });
  }
  uomPopupEnterKeyEventHandler = (e) => {
    let criteria = this.state.criteria;
    let uomCode = e.target.value;
    criteria.uomCode = uomCode;
    let uomData_List = this.state.uoms;
    let UomCodeBean = null;
    uomData_List.map((uom) => {
      if (uom.code == e.target.value) {
        UomCodeBean = uom;
      }
    });
    if (!isEmpty(UomCodeBean)) {
      let criteria = this.state.criteria;
      criteria.uomCode = UomCodeBean.code;
      this.setState({
        criteria: criteria,
        uomPopupPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteUomPopupList = (showAutoCompleteUOMPopupList) => {
    this.setState({
      showAutoCompleteUOMPopupList: showAutoCompleteUOMPopupList,
    });
  };
  generatePDF = () => {
    this.generatefabricStyleInventoryReport(1);
  };
  generateExcel = () => {
    this.generatefabricStyleInventoryReport(2);
  };
  generatefabricStyleInventoryReport = (reportType) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ...",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new FabricStyleInventoryValuationPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.FabricStyleInventoryValuationInfosInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateFabricStyleInventoryValuationPrintReport(
          listRequest,
          this.generateFabricStyleInventoryPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.FabricStyleInventoryValuationInfosInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateFabricStyleInventoryValuationPrintReport(
          listRequest,
          this.generateFabricStyleInventoryPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateFabricStyleInventoryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showHideSecondHeader = (e) => {
    if (e.detail === 1) {
      let isCollapsible_open = !this.state.isCollapsible_open;
      this.setState({ isCollapsible_open: isCollapsible_open });
    }
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item " : "FabricStyle",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "6", "", "wt-6", "wt-6")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SKU#", "skuNumber", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty", "onHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "totalOnHandQuantity")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Cost", "cost", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalAmt(Cost)", "purchaseValuationAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "totalPurchaseValueAmount")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("LandedCost", "landedCost", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("FOB Cost", "fobCost", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalAmt(Land)", "totalInventoryLandedCost", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "totalLandedCostInventoryAmount")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalAmt(FOB)", "totalInventoryFOBCost", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "totalFOBCostInventoryAmount")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleName", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("customer", "reservedCustomerCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("customer Name", "reservedCustomerName", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    return columns;
  };

  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let inquiryData = this.state.inquiryData;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={
            this.state.is3PL
              ? "Item Style Inventory Valuation Info"
              : "Fabric Style Inventory Valuation Info"
          }
          isShowExitButton={this.state.isShowExitButton}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          onChange={this.onChange}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
          locationEnterKeyEventHandler={this.locationEnterKeyEventHandler}
          displayAutoCompleteLocationList={this.displayAutoCompleteLocationList}
          locationCodeOnChange={this.locationCodeOnChange}
          uomPopupEnterKeyEventHandler={this.uomPopupEnterKeyEventHandler}
          displayAutoCompleteUomPopupList={this.displayAutoCompleteUomPopupList}
          onPopupUomCodeChange={this.onPopupUomCodeChange}
          showHideSecondHeader={this.showHideSecondHeader}
        />
        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
              subHeaderData={inquiryData}
            />
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowFabricStyleModule}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const onChange = (e) => props.onChange(e);
  let criteria = props.criteria;
  let fabricLookupHandler = props.fabricLookupHandler;
  let warehouseLookupHandler = props.warehouseLookupHandler;
  let uomsLookupHandler = props.uomsLookupHandler;
  let fabricCodeRef = React.createRef();
  let colorCodeRef = React.createRef();
  const fabricCodeOnChange = (e) => {
    props.fabricCodeOnChange(e);
  };
  const onFabricColourCodeChange = (e) => {
    props.onFabricColourCodeChange(e);
  };
  const locationCodeOnChange = (e) => {
    props.locationCodeOnChange(e);
  };
  const onPopupUomCodeChange = (e) => {
    props.onPopupUomCodeChange(e);
  };
  const fabricEnterKeyEventHandler = (e) => {
    props.fabricEnterKeyEventHandler(e);
  };
  const locationEnterKeyEventHandler = (e) => {
    props.locationEnterKeyEventHandler(e);
  };
  const fabricColourEnterKeyEventHandler = (e) => {
    props.fabricColourEnterKeyEventHandler(e);
  };
  const uomPopupEnterKeyEventHandler = (e) => {
    props.uomPopupEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricList = () => {
    props.displayAutoCompleteFabricList();
  };
  const displayAutoCompleteFabricColorList = () => {
    props.displayAutoCompleteFabricColorList();
  };
  const displayAutoCompleteLocationList = () => {
    props.displayAutoCompleteLocationList();
  };
  const displayAutoCompleteUomPopupList = () => {
    props.displayAutoCompleteUomPopupList();
  };
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {props.is3PL ? (
            <FormLabel>Item</FormLabel>
          ) : (
            <FormLabel>FabricStyle</FormLabel>
          )}
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={fabricCodeRef}
            name="fabricStyleCode"
            onChange={fabricCodeOnChange}
            value={criteria.fabricStyleCode}
            lookupRequired={props.isShowLookup}
            lookupHandler={fabricLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={fabricEnterKeyEventHandler}
            autoCompleteListData={props.fabricPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricList}
            showAutoCompleteList={props.showAutoCompleteFabricList}
            disabled={props.isDisableFields}
          />
        </Col>
        <Col sm="2">
          <InputTextbox
            name="fabricStyleName"
            onChange={onChange}
            value={criteria.fabricStyleName}
            disabled={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel>Color</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={colorCodeRef}
            onChange={onFabricColourCodeChange}
            name="colorCode"
            placeholder="color"
            value={criteria.colorCode}
            lookupRequired={props.isShowColorLookup}
            lookupHandler={props.colorLookupHandler}
            enterKeyEventHandler={fabricColourEnterKeyEventHandler}
            autoCompleteListData={props.fabricColourPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricColorList}
            showAutoCompleteList={props.showAutoCompleteFabricColorList}
            disabled={props.isDisableFields}
          />
        </Col>
        <Col sm="1">
          <FormLabel>UOM</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            onChange={onPopupUomCodeChange}
            name="uomCode"
            placeholder="uomcode"
            value={criteria.uomCode}
            lookupRequired={props.isShowLookup}
            lookupHandler={uomsLookupHandler}
            enterKeyEventHandler={uomPopupEnterKeyEventHandler}
            autoCompleteListData={props.uomPopupPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteUomPopupList}
            showAutoCompleteList={props.showAutoCompleteUOMPopupList}
            disabled={props.isDisableFields}
          />
        </Col>
        <Col>
          <CollapseComponent
            isOpen={props.isCollapsible_open}
            onClick={(e) => props.showHideSecondHeader(e)}
          />
        </Col>
      </Row>
      {props.isCollapsible_open && (
        <Row>
          <Col sm="1">
            <FormLabel>Location</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={locationCodeOnChange}
              name="locationCode"
              placeholder="location"
              value={criteria.locationCode}
              lookupRequired={props.isShowLookup}
              lookupHandler={warehouseLookupHandler}
              enterKeyEventHandler={locationEnterKeyEventHandler}
              autoCompleteListData={props.locationPageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={displayAutoCompleteLocationList}
              showAutoCompleteList={props.showAutoCompleteLocationList}
              disabled={props.isDisableFields}
            />
          </Col>
        </Row>
      )}
    </div>
  );
}
function FabricStyleInventoryValuationInfoModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App"></div>
      <FabricStyleInventoryValuationInfo {...props} name="" />
      <br />
    </div>
  );
}

export default FabricStyleInventoryValuationInfoModule;
